export default [
  {
    path: '/front-covers',
    name: 'front-cover',
    meta: { requiresAuth: true },
    component: () => import('@/pages/administrator/front-cover/index')
  }
]
